import { gql } from "apollo-boost";

// eslint-disable-next-line import/prefer-default-export
export const GET_CREDIT_BOOST_TRANSACTIONS = gql`
  query CreditBoostTransactions {
    getCreditBoostTransactions {
      transactions {
        id
        amount
        posteddate
        description
        memo
        normalizedpayee
        institutiontransactionid
        category
        payee_id
        status
        institution_name
        institution_account_name
        institution_id
        created_at
        posted_date
      }
      payees {
        id
        aliases
        created_at
      }
    }
  }
`;

export const GET_NON_MATCHED_TRANSACTIONS_GQL = gql`
query getNonMatchedTransactions {
  getNonMatchedTransactions {
    transactions {
      id
      amount
      posteddate
      description
      memo
      normalizedpayee
      institutiontransactionid
      category
      payee_id
      status
      institution_name
      institution_account_name
      institution_id
      created_at
      posted_date
      source
    }
    payees {
      id
      aliases
      created_at
    }
  }
}
`;
export const GET_STRIPE_PAYMENT_LINK = gql`
  query StripePaymentLink {
    generateStripePaymentLink {
      link
    }
  }
`;

export const GET_PRODUCT_STATUS = gql`
  query ProductStatus($productId: String = "credit_boost") {
    getUserProductStatus(productId: $productId) {
      status
      productTier
      productTerm
      productFreeTrial
    }
  }
`;

export const GET_BOOST_PAST_DUE_AMOUNT = gql`
  query PastDueAmount($productId: String = "credit_boost") {
    getUserProductStatus(productId: $productId) {
      pastDueAmount
    }
  }
`;

export const VALIDATE_ADDRESS = gql`
  query validateUserAddress($address: ValidateAddressInput) {
    validateAddressV2(address: $address) {
      error
      address {
        street1
        street2
        state
        city
        zip
      }
    }
  }
`;

export const GET_BOOST_BASIC_INFO = gql`
  query BasicInfo($sessionId: String) {
    getUserBasicInfo(sessionId: $sessionId) {
      user {
        firstName
        lastName
        email
        phoneNumber
        ssnLastFour
        applicationStatus
        dob
        passwordExists
        addresses {
          address_type
          street
          city
          state
          zip
          country
          unit_number
        }
        referralCode
      }
      stripeUser {
        address {
          city
          country
          line1
          line2
          postal_code
          state
        }
        email
        name
        phone
      }
    }
  }
`;

export const SUBMIT_BASIC_USER_INFO = gql`
  mutation submitBasicUserInfo(
    $userInfo: BasicBoostUserSubmit
  ){
    submitBasicUserInfo(
      userInfo: $userInfo
    ) {
      status
    }
  }
`;

export const SUBMIT_BOOST_SELF_ADD_TRANSACTION = gql`
  mutation submitSelfAddTransaction(
    $transaction: BoostSelfAddTransaction!
  ){
    submitSelfAddTransaction(
      transaction: $transaction
    ) {
      status
    }
  }
`;

export const SUBMIT_CREDIT_BOOST_TRANSACTIONS = gql`
  mutation submitCreditBoostTransactions(
    $transactionIds: [ID]
    $updateAll: Boolean
  ) {
    submitCreditBoostTransactions(
      transactionIds: $transactionIds
      updateAll: $updateAll
    ) {
      status
    }
  }
`;

export const UPDATE_CREDIT_BOOST_ELIGIBILITY = gql`
  mutation updateCreditBoostEligibility($loadTransactions: Boolean) {
    updateCreditBoostEligibility(loadTransactions: $loadTransactions) {
      enrollment_status
      transactions {
        id
        amount
        posteddate
        description
        memo
        normalizedpayee
        institutiontransactionid
        category
        payee_id
        status
        institution_name
        institution_account_name
        institution_id
        created_at
        posted_date
      }
      payees {
        id
        aliases
        created_at
      }
    }
  }
`;

export const UPDATE_FINICITY_ACCOUNTS_BOOST = gql`
  mutation updateFinicityAccountsTransactions {
    updateFinicityAccountsTransactions {
      status
    }
  }
`;

export const GET_USER_BANK_ACCOUNTS = gql`
  query getUserBankAccounts {
    getUserBankAccounts {
      institutionName
      logoURL
      accounts {
        uuid
        mask
        name
        type
        appliedProducts
        statusCodeUpdatedAt
      }
    }
  }
`;

export const UPDATE_BOOST_SUBSCRIPTION_TIER = gql`
  mutation updateCreditBoostSubscriptionTier(
    $productTier: String!
    $productTerm: String
    $promoCode: String
  ) {
    updateCreditBoostSubscriptionTier(
      productTier: $productTier
      productTerm: $productTerm
      promoCode: $promoCode
    ) {
      status
      message
    }
  }
`;

export const RESUME_BOOST_SUBSCRIPTION_TIER = gql`
  mutation resumeBoostSubscription(
    $applyDiscountCode: String
  ) {
    resumeBoostSubscription(
      applyDiscountCode: $applyDiscountCode
    ) {
      status
    }
  }
`;

export const CHECK_PROMO_CODE_VALID = gql`
  query checkPromoCodeValid(
    $productTier: String!
    $productTerm: String!
    $promoCode: String!
    $isUpgrade: Boolean
  ) {
    checkPromoCodeValid(
      productTier: $productTier
      productTerm: $productTerm
      promoCode: $promoCode
      isUpgrade: $isUpgrade
    ) {
      valid
      reason
      credit
      type
    }
  }
`;

export const GET_BOOST_UPCOMING_INVOICE = gql`
  query getUserBoostUpcomingInvoiceWithUpdate(
    $productTier: String!
    $productTerm: String!
    $promoCode: String
  ) {
    getUserBoostUpcomingInvoiceWithUpdate(
      productTier: $productTier
      productTerm: $productTerm
      promoCode: $promoCode
    ) {
      startingBalance
      amountCharged
      amountDue
    }
  }
`;

export const USER_CREDIT_SCORE_QUERY = gql`
  query UserCreditScore($order: String!, $limit: Int!) {
    getUserCreditScore(order: $order, limit: $limit) {
      credit_scores {
        credit_score
        date_pulled_at
        credit_scoring_model
        credit_summary {
          credit_utilization
          oldest_credit_opened_date
          credit_checks
          total_opened_accounts
        }
      }
      details {
        status
        transunion {
          lockedAt
        }
      }
    }
  }
`;